import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ children, className = '' }) => {
  return (
    <div
      className={`h-full bg-white rounded-lg shadow-sm border border-gray-200 pt-4 pb-4 px-2 ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
